import styled from "styled-components";

export const Button = styled.button`
  width: 346px;
  height: 46px;
  color: ${({ color }) => color || "#ffffff"};
  background-color: ${({ color }) => color ? 'transparent' : "#b61817"};
  border: 2px solid ${({ color }) => color || "#b61817"};
  border-radius: 4px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    box-shadow: 0px 0px 16px #848484;
  }
  &:disabled {
    color: #d1d1d1;
    background-color: #ffffff;
    border: 2px solid #d1d1d1;
    &:hover {
      box-shadow: 0px 0px 16px transparent;
    }
  }
`;
